export const getPreferredPaId = (
  savedFilters: string | undefined
): string | undefined => {
  if (!savedFilters) return undefined;
  const agreements = new URLSearchParams(savedFilters).get('agreements');
  return agreements?.match(/pa:(\d+)/)?.[1];
};
